import { getRoutesPathsByFileContext } from '@maxtropy/components';

// 获取所有pages文件夹中所有子文件中的routes.tsx
const routesContext = require.context('../pages', true, /routes\.tsx$/);
const mainRoutesPaths = getRoutesPathsByFileContext(routesContext);

export default mainRoutesPaths;
